import { withInstall } from '@vuemap/vue-amap-util'
import Vector from './Vector.vue'

export const ElAmapLayerVector = withInstall(Vector)
export default ElAmapLayerVector
